import React from 'react'
import BEMHelper from '@ynap/bem-helper'
import { useMessages } from '@ynap/immutables-provider'

const bem = new BEMHelper('SustainabilityInfo')

const orderConfirmationSelector = (messages) => messages?.orderConfirmation

const SustainabilityInfo = () => {
    const orderConfirmationMessages = useMessages(orderConfirmationSelector)

    const blocks = [1, 2, 3]

    return (
        <section className={bem('container')}>
            <h4 className={bem('header')}>{orderConfirmationMessages?.sustainabilityInfoHeader?.()}</h4>
            <div className={bem('blocksContainer')}>
                {blocks.map((index) => (
                    <React.Fragment key={index}>
                        <article className={bem('block')}>
                            <h5 className={bem('blockHeader')}>{orderConfirmationMessages?.sustainabilityInfoBlock?.header({ index: `header${index}` })}</h5>
                            <span className={bem('blockTitle')}>{orderConfirmationMessages?.sustainabilityInfoBlock?.title({ index: `title${index}` })}</span>
                            <span className={bem('blockText')}>{orderConfirmationMessages?.sustainabilityInfoBlock?.text({ index: `text${index}` })}</span>
                        </article>
                        {index < blocks.length && <div className={bem('blockDivider')} />}
                    </React.Fragment>
                ))}
            </div>
        </section>
    )
}

export default SustainabilityInfo
